<template>
  <vx-card title="New Ticket">
    <ValidationObserver v-slot="{ invalid }">
      <div class="vx-row mb-5">
        <div class="vx-col w-full">
          <label for class="vs-select--label">Title</label>
          <ValidationProvider
            immediate
            name="title"
            rules="required|min:1|max:100"
            v-slot="{ errors }"
          >
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-info"
              placeholder="Ex: About my order..."
              icon-no-border
              v-model="form.title"
              :success="errors.length === 0"
              success-text="Ticket title is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="vx-row mb-8">
        <div class="vx-col w-full">
          <label for class="vs-select--label">Priority</label>
          <vs-select
            :success="[1,2,3].indexOf(form.priority) !== -1"
            success-text="Priority is valid."
            :danger="[1,2,3].indexOf(form.priority) === -1"
            v-model="form.priority"
            name="included"
            icon-pack="feather"
            icon="icon-alert-circle"
            icon-no-border
            class="select-large w-full"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in priority_options"
            />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label for class="vs-select--label">Message</label>
          <ValidationProvider
            immediate
            name="message"
            rules="required|min:2|max:1000"
            v-slot="{ errors }"
          >
            <vs-textarea
              class="w-full"
              icon-pack="feather"
              icon="icon-info"
              icon-no-border
              label="Specify your problem here with maximum 1000 characters."
              placeholder="I've been having problem with..."
              style="min-height: 150px;"
              v-model="form.message"
              :success="errors.length === 0"
              success-text="Ticket message is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="createTicket" :disabled="invalid">Create Ticket</vs-button>
          <router-link to="/tickets">
            <vs-button color="warning" type="border" class="mb-2">Back</vs-button>
          </router-link>
        </div>
      </div>
    </ValidationObserver>
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      form: {
        title: '',
        priority: 2,
        message: ''
      },
      priority_options: [
        { text: 'High', value: 3 },
        { text: 'Medium', value: 2 },
        { text: 'Low', value: 1 }
      ]
    }
  },
  methods: {
    createTicket () {
      const data = {
        title: this.form.title,
        priority: this.form.priority,
        messages: [{ message: this.form.message }]
      }
      this.$http
        .post('/user/tickets', data)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              position: 'bottom-start',
              icon: 'success',
              toast: true,
              title: res.data.message,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true
            })
            this.$router.push('/tickets')
          }
        })
        .catch(err => {
          this.$swal({
            position: 'bottom-start',
            icon: 'error',
            toast: true,
            title: err.response.data.message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          })
        })
    }
  }
}
</script>

<style scoped>
.vs-textarea {
  margin-top: 20px;
}
</style>
